import React from 'react';
import { Eye, Lock, Trash2, User, Mail, Phone, Calendar, Users as UsersIcon, Building } from 'lucide-react';

const UtilisateurCard = ({ utilisateur, onView, onChangePassword, onDelete }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusBadge = () => {
    if (utilisateur.is_active) {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Actif
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
        Inactif
      </span>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
      {/* Image de couverture */}
      <div className="relative h-32 bg-gradient-to-br from-[#FF6B00] to-[#437011]">
        {utilisateur.photo_couverture && (
          <img
            src={utilisateur.photo_couverture}
            alt="Couverture"
            className="w-full h-full object-cover"
          />
        )}
        
        {/* Photo de profil */}
        <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
          {utilisateur.image ? (
            <img
              src={utilisateur.image}
              alt={utilisateur.username}
              className="w-24 h-24 rounded-full border-4 border-white object-cover shadow-lg"
            />
          ) : (
            <div className="w-24 h-24 rounded-full border-4 border-white bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center shadow-lg">
              <User className="w-12 h-12 text-gray-400" />
            </div>
          )}
        </div>
        
        {/* Badge de statut */}
        <div className="absolute top-3 right-3">
          {getStatusBadge()}
        </div>
      </div>

      <div className="pt-16 px-6 pb-6">
        {/* Nom et username */}
        <div className="text-center mb-6">
          <h3 className="text-xl font-bold text-gray-900 mb-1">
            {utilisateur.full_name || utilisateur.username}
          </h3>
          <p className="text-sm text-gray-500">@{utilisateur.username}</p>
        </div>

        {/* Informations de contact */}
        <div className="space-y-3 mb-6">
          {utilisateur.email && (
            <div className="flex items-center gap-3 text-sm text-gray-600 bg-gray-50 p-2 rounded-lg">
              <Mail className="w-4 h-4 text-[#FF6B00] flex-shrink-0" />
              <span className="truncate">{utilisateur.email}</span>
            </div>
          )}
          
          {utilisateur.telephone && (
            <div className="flex items-center gap-3 text-sm text-gray-600 bg-gray-50 p-2 rounded-lg">
              <Phone className="w-4 h-4 text-[#437011] flex-shrink-0" />
              <span>{utilisateur.telephone}</span>
            </div>
          )}

          {utilisateur.type_entreprise && (
            <div className="flex items-center gap-3 text-sm text-gray-600 bg-gray-50 p-2 rounded-lg">
              <Building className="w-4 h-4 text-blue-500 flex-shrink-0" />
              <span>{utilisateur.type_entreprise}</span>
            </div>
          )}
        </div>

        {/* Statistiques */}
        <div className="flex items-center justify-between mb-6 p-3 bg-[#F4F8E9] rounded-lg">
          <div className="flex items-center gap-2">
            <UsersIcon className="w-4 h-4 text-[#FF6B00]" />
            <span className="text-sm font-medium text-gray-700">{utilisateur.amis_count || 0} amis</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4 text-[#437011]" />
            <span className="text-xs text-gray-500">Inscrit le {formatDate(utilisateur.date_joined)}</span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
          <button
            onClick={() => onView(utilisateur)}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 font-medium shadow-sm hover:shadow-md"
          >
            <Eye className="w-4 h-4" />
            <span>Voir</span>
          </button>
          <button
            onClick={() => onChangePassword(utilisateur)}
            className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#FF6B00] text-white rounded-lg hover:bg-[#E55A00] transition-all duration-200 shadow-sm hover:shadow-md"
            title="Changer le mot de passe"
          >
            <Lock className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete(utilisateur.id)}
            className="flex items-center justify-center gap-2 px-4 py-2.5 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-200 shadow-sm hover:shadow-md"
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UtilisateurCard;
